"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ListBucketsInput_1 = require("./ListBucketsInput");
var ListBucketsOutput_1 = require("./ListBucketsOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.ListBuckets = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "ListBuckets",
    http: {
        method: "GET",
        requestUri: "/"
    },
    input: {
        shape: ListBucketsInput_1.ListBucketsInput
    },
    output: {
        shape: ListBucketsOutput_1.ListBucketsOutput
    },
    errors: []
};
//# sourceMappingURL=ListBuckets.js.map